<template>
  <div id="enter-banner">
    <div class="center">
        <p>Simply upload a picture of you and your Jeep Grille to be in the draw to <strong>win a brand new Jeep Renegade Longitude!</strong></p>
        <a href="https://www.jeepgrilles.co.nz" target="_blank" class="button">ENTER COMPETITION</a>
        <img alt="Jeep Vehicle" src="@/assets/jeep-vehicle.png">
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style scoped lang="scss">
@import "../scss/variables.scss";
#enter-banner {
  width: 100%;
  padding: 30px 3%;
  background: #282828;

  text-align: center;

  .center {
      position: relative;
      max-width: 290px;
      margin: 0 auto 16px;

      @media (min-width: $mediumish) {
        max-width: 569px;
      }

      p {
        margin-bottom: 36px;
        font-family: $font-family-1;
        font-size: 22px;
        font-weight: 700;
        color: white;

        strong {
            color: $color-1a;
        }
      }

      .button {
        padding: 10px 26px;
      }

      img {
          margin: 60px auto 0;

          @media (min-width: $medium) {
            position: absolute;
            top: -52px;
            right: -328px;

            margin: auto;
          }
      }
  }
}
</style>
